import { LabelBox } from "../../";
import { getLabelName } from "../../../utils";
import React, { FC } from "react";
import {
  CompanySettingModel,
  DailyTransactionTypeEnum,
  TransactionDetailResponseModel,
  TransactionItemResponseModel,
} from "../../../models";
import {labelBoxLabelStyle, labelBoxValueStyle} from "../common/css/posCss";

export const PosTransactionSummary: FC<{
  data: TransactionDetailResponseModel;
  companySettings: CompanySettingModel;
}> = ({ data, companySettings }) => {
  //#region functions
  const handleCalculateTotalQuantity = (
    request: TransactionDetailResponseModel
  ): number => {
    return (
      request?.TransactionDetaillist?.reduce(
        (accumulator: number, currentItem: TransactionItemResponseModel) => {
          return accumulator + currentItem.Quantity;
        },
        0
      ) || 0
    );
  };
  //#endregion
  //#region html
  return (
    <>
      <div
        style={{
          backgroundColor:
            data.TransactionType === DailyTransactionTypeEnum.POSSalesRefund
              ? "lightblue"
              : "#fff",
          border: "1px solid #ccc",
          borderRadius: "8px",
          padding: "1rem",
        }}
        className="mb-2"
      >
        <div className="row g-2">
          <div className="col-12 col-md-4">
              <LabelBox
                id="totalQuantities"
                labelName={getLabelName("Quantity")}
                inputValue={handleCalculateTotalQuantity(data)}
                labelStyle={labelBoxLabelStyle}
                valueStyle={labelBoxValueStyle}
              />
            </div>
          <div className="col-12 col-md-4">
              <LabelBox
                id="totalMoneyInCurrency"
                labelName={getLabelName("Total")}
                inputValue={data.TotalMonyInCurrency}
                labelStyle={labelBoxLabelStyle}
                valueStyle={labelBoxValueStyle}
              />
            </div>
          <div className="col-12 col-md-4">
              <LabelBox
                id="discountInCurrency"
                labelName={getLabelName("Discount")}
                inputValue={data.DiscountInCurrency}
                labelStyle={labelBoxLabelStyle}
                valueStyle={labelBoxValueStyle}
              />
            </div>
            {companySettings.ApplyTax && (
                <div className="col-12 col-md-6">
                <LabelBox
                  id="taxValueInCurrency"
                  labelName={getLabelName("Tax_Value")}
                  inputValue={data.TotalTaxInCurrency}
                  labelStyle={labelBoxLabelStyle}
                  valueStyle={labelBoxValueStyle}
                />
              </div>
            )}
          <div className={`col-12 ${companySettings.ApplyTax ? 'col-md-6' : 'col-md-12'}`}>
              <LabelBox
                id="netBillInCurrency"
                labelName={getLabelName("Net Bill")}
                inputValue={data.TotalNetInCurrency}
                labelStyle={labelBoxLabelStyle}
                valueStyle={labelBoxValueStyle}
              />
            </div>
        </div>
      </div>
    </>
  );
  //#endregion
};
